export { StudentQuestDetailPage } from "./StudentQuestDetailPage"
export type {
    StudentQuestDetailPageProps,
    StudentQuestDetailComposition,
    UIQuestDetail,
} from "./StudentQuestDetailPage"
